'use strict';

const MailParser = require('./lib/mail-parser');
const simpleParser = require('./lib/simple-parser');

module.exports = {
    MailParser,
    simpleParser
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mailparser/index.js
// module id = nKdL
// module chunks = 0